import type { SyntheticEvent } from "react";

const preventDefault = (e: SyntheticEvent) => e && e.preventDefault && e.preventDefault();
export default preventDefault;
